'use client'

import React, { useEffect, useRef } from 'react'

type Props = {
  src: string
  async?: boolean
}

export const ScriptContent = ({ src, async = false }: Props) => {
  const ref = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = src
    script.async = async

    if (ref.current) {
      ref.current.innerHTML = ''
      ref.current.appendChild(script)
    }
  }, [])

  return <span ref={ref} />
}
